
import { defineComponent, PropType } from 'vue'
import { RepeatPersonDto } from '@/api/pay'
import tableComponent from '@/components/table-component/index.vue'

export default defineComponent({
    components: {
        tableComponent
    },
    data() {
        return {
            tableHead: [
                { prop: 'userName', label: '姓名', width: 160 },
                { prop: 'idCardLastFour', label: '身份证号', width: 260 }
            ]
        }
    },
    props: {
        list: {
            type: Array as PropType<RepeatPersonDto[]>,
            default: () => []
        }
    },
    emits: ['cancel', 'confirm'],
    methods: {
        onCancel() {
            this.$emit('cancel')
        },
        onConfirm() {
            this.$emit('confirm')
        }
    }
})
